import { render, staticRenderFns } from "./PsPatientListAllWeights.vue?vue&type=template&id=50f7c76c&scoped=true&"
import script from "./PsPatientListAllWeights.vue?vue&type=script&lang=js&"
export * from "./PsPatientListAllWeights.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientListAllWeights.vue?vue&type=style&index=0&id=50f7c76c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7c76c",
  null
  
)

export default component.exports